// src/components/CartPageRight.js
import React from 'react';
import { BsInfoCircleFill } from 'react-icons/bs';
import ProductInfoModal from '../ProductInfoModal/ProductInfoModal'; 
import DeleteModal from '../DeleteModal/DeleteModal';

const CartPageRight = ({
  cartItemsWithDetails,
  subtotal,
  shippingFee,
  openProductInfo,
  openDeleteModal,
  selectedProduct,
  isDeleteModalOpen,
  productToDelete,
  deleteQuantity,
  handleDeleteQuantityChange,
  handleDelete,
  closeDeleteModal
}) => {

  return (
    <div className="cart-page-right">
      <div className="cart-summary-container">
        <div className="cart-header">
          <h2>Shopping Cart</h2>
          {cartItemsWithDetails.length > 0 && (
            <span className="cart-header-item-count">
              {cartItemsWithDetails.reduce((total, item) => total + item.quantity, 0)} {/* Total quantity */}
            </span>
          )}
        </div>

        <hr className="section-divider" />
        <div className="cart-items">
          {cartItemsWithDetails.length > 0 ? (
            cartItemsWithDetails.map((item) => (
              <div key={`${item._id}-${item.selectedSize}-${item.selectedColor}`} className="cart-item">
                <div className="item-details">
                  <img 
                    src={item.images && item.images.length > 0 ? item.images[0] : '/path/to/default-image.jpg'} 
                    alt={item.name} 
                    className="cart-item-image" 
                  />
                  <div className="cart-item-info">
                    <div className="item-name-quantity">
                      <p className="item-name">{item.name}</p>
                      <p className="item-quantity">x{item.quantity}</p>
                    </div>


                    <p className="item-price">Price: ${item.new_price}</p>
                    <p className="item-total">
                      Total: ${(item.new_price * item.quantity).toFixed(2)}
                    </p>
                  </div>
                </div>

                <div
                  className="info-button"
                  onClick={() => openProductInfo(item)} 
                >
                  <BsInfoCircleFill size={20} className="info-icon" />
                </div>

                <div
                  className="remove-button"
                  onClick={() => openDeleteModal(item, item.quantity)} 
                >
                  X
                </div>
              </div>
            ))
          ) : (
            <p>Your cart is empty!</p>
          )}
        </div>

        <hr className="section-divider" />

        <div className="subtotal">
          <p>Subtotal:</p>
          <p>${subtotal.toFixed(2)}</p>
        </div>

        <div className="shipping-fee">
          <p>Shipping:</p> 
          <p>{shippingFee === 0 ? 'Free' : `$${shippingFee.toFixed(2)}`}</p>
        </div>

        <hr className="section-divider" />

        <div className="total-price">
          <p>Total:</p>
          <p>${(subtotal + shippingFee).toFixed(2)}</p>
        </div>
      </div>

      {selectedProduct && (
        <ProductInfoModal
          product={selectedProduct}
          onClose={() => openProductInfo(null)}
        />
      )}

      {isDeleteModalOpen && (
        <DeleteModal
          productToDelete={productToDelete}
          deleteQuantity={deleteQuantity}
          handleDeleteQuantityChange={handleDeleteQuantityChange}
          handleDelete={handleDelete}
          closeDeleteModal={closeDeleteModal}
        />
      )}
    </div>
  );
};

export default CartPageRight;
